import React from "react";
import { Typography, type TypographyVariant } from "@mui/material";
import DOMPurify from "dompurify";

export default function NoteText({
  text,
  variant = "body1",
}: {
  text: string;
  variant: TypographyVariant | "inherit";
}) {
  const processedText = text.replaceAll("\n", "<br />");

  const finalText = DOMPurify.sanitize(processedText, {
    ALLOWED_TAGS: ["highlight", "b", "br"],
    RETURN_TRUSTED_TYPE: true,
  });

  return (
    <Typography
      variant={variant}
      dangerouslySetInnerHTML={{ __html: finalText }}
      sx={{
        whiteSpace: "pre-wrap",
        overflow: "auto",
        highlight: {
          background: "rgba(0, 73, 84, 0.3)",
          padding: "0 2px",
        },
      }}
    />
  );
}
